import { Controller } from '@hotwired/stimulus'

export default class AccountTypeMappingsCreateFormController extends Controller<HTMLFormElement> {
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly pendingMessageTarget: HTMLElement
  static targets = ['button', 'pendingMessage']
  connect() {
    this.buttonTarget.classList.add('absolute', '-left-[100vw]')
  }

  autoSubmit() {
    this.pendingMessageTarget.classList.remove('hidden')
    this.#togglePendingMessage()
    this.element.requestSubmit()
  }

  #togglePendingMessage(direction?: PlaybackDirection) {
    direction ??= 'normal'
    const options: KeyframeAnimationOptions = {
      direction,
      duration: 300,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'both',
    }
    return this.pendingMessageTarget.animate([{ opacity: 0 }, { opacity: 0.8 }], options)
  }
}
